import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import { Field, reduxForm } from "redux-form";
import { TextField } from "redux-form-material-ui";
import { munvoBlue } from "../utils/globalStyles";
import * as Constants from "../utils/Constants";
import { isValidPassword } from "../utils/generalUtils";

class ProfileForm extends Component {
  render() {
    const { handleSubmit } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <Grid container>
          <Grid item xs={12}>
            <Field
              component={TextField}
              type="password"
              floatingLabelText="Previous Password"
              name="previousPassword"
              underlineStyle={{ borderColor: munvoBlue }}
              underlineFocusStyle={{ borderColor: munvoBlue }}
              floatingLabelFocusStyle={{ color: munvoBlue }}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              component={TextField}
              type="password"
              floatingLabelText="New Password"
              name="password"
              underlineStyle={{ borderColor: munvoBlue }}
              underlineFocusStyle={{ borderColor: munvoBlue }}
              floatingLabelFocusStyle={{ color: munvoBlue }}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              component={TextField}
              type="password"
              floatingLabelText="Confirm New Password"
              name="confirmPassword"
              underlineStyle={{ borderColor: munvoBlue }}
              underlineFocusStyle={{ borderColor: munvoBlue }}
              floatingLabelFocusStyle={{ color: munvoBlue }}
            />
          </Grid>
        </Grid>
      </form>
    );
  }
}

ProfileForm.propTypes = {
  submitCallback: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired
};

const validate = values => {
  const errors = {};

  if (!values.previousPassword) {
    errors.password = "Required";
  }
  if (!values.password) {
    errors.password = "Required";
  }
  if (!values.confirmPassword) {
    errors.confirmPassword = "Required";
  } else if (values.password !== values.confirmPassword) {
    errors.confirmPassword = "Password mismatched";
  }

    //check if pwd contains a number a letter and is of size greater then pwdlength
    if(!isValidPassword(values.password)){
      errors.password =
      "Password should be longer than " +
      Constants.PASSWORDLENGTH.toString() +
      " character long and contain both a letter and a number";
    }
    
    
  
  
    if (!values.password) {
      errors.password = "Required";
    }
    return errors;

};

export default reduxForm({
  form: "profileForm",
  validate,
  onSubmit: (values, dispatch, props) => {
    props.submitCallback(values);
  }
})(ProfileForm);
